import * as d3 from "d3";
import { Chart } from "@/utils/Chart";
import i18n from "../lang/lang";

export function ChartPie(
  alias,
  chartData,
  innerRadius,
  showValuesOnTop = true,
  margin = {
    top: 0,
    right: 70,
    bottom: 20,
    left: 70,
  }, squaredChart = false, fontSize = 1
) {
  this.alias = alias;
  this.chartData = chartData;
  this.data = chartData.data;
  this.innerRadius = innerRadius || 0;
  var chart = new Chart(alias, false, margin, squaredChart);
  this.total = 0;


  this.render = function () {
    chart.svg.attr(
      "transform",
      "translate(" +
        chart.svgWidth / 2 +
        "," +
        (chart.svgHeight - chart.margin.bottom) / 2 +
        ")"
    );
    var radius = Math.min(chart.chartWidth, chart.chartHeight) / 2;

    var arc = d3.arc().outerRadius(radius).innerRadius(this.innerRadius);

    var labelArc = d3
      .arc()
      .outerRadius(radius / 1.3)
      .innerRadius(radius / 1.3);

    this.data.map((d) => {
      this.total += d.value;
    });
    var pie = d3
      .pie()
      .sort(null)
      .value(function (d) {
        if (d.type === "percentage") {
          return d.value;
        } else {
          return d.value;
        }
      });

    var g = chart.svg
      .selectAll(".arc")
      .data(pie(this.data))
      .enter()
      .append("g")
      .attr("class", "arc");

    g.append("path")
      .attr("d", arc)
      .style("fill", (d) => {
        return d.data.color || chart.getColor(d.data.label);
      })
      .on("mouseover", (data) => {
        chart.openTooltip(
          chart.format(data.data, true) + " " + i18n.tc(data.data.label),fontSize
        );
      });
    g.on("mouseout", function () {
      chart.closeTooltip();
    }).on("mousemove", function () {
      chart.moveTooltip(0, 0);
    });

    var previousSmallAngle = false;
    g.each(function (d) {
      if (isSmallAngle(d.startAngle, d.endAngle)) {
        if (previousSmallAngle) {
          d["showText"] = false;
        } else {
          d3.select(this).raise();
          d["showText"] = true;
        }
        previousSmallAngle = true;
      } else {
        previousSmallAngle = false;
        d["showText"] = true;
      }
    });

    if (showValuesOnTop) {
      g.append("text")
        .attr("transform", function (d) {
          const labelArcToUse = labelArc;
          return "translate(" + labelArcToUse.centroid(d) + ")";
        })
        .style("font-size", this.fontSize + "rem")
        .style("font-family", "Oswald-Light")
        .style("font-size", "12px")
        .style("text-anchor", "middle")
        .style("pointer-events", "none")
        .style("display", function (d) {
          return d.showText ? "inherit" : "none";
        })
        .attr("x", function () {
          return 0;
        })
        .attr("y", function () {
          return 0;
        })
        .text(function (d) {
          return chart.format(d.data, true);
        })
        .call(chart.wrap, 50);
    }

    function isSmallAngle(startAngle, endAngle) {
      const MINIMUM_ANGLE_DIFFERENCE = 0.5;
      if (endAngle - startAngle < MINIMUM_ANGLE_DIFFERENCE) {
        return true;
      }
      return false;
    }
  };
}
